import { acrListMiddleware as getAcrListMiddleware } from './acr-list-middleware';

export const acrMiddleware = [getAcrListMiddleware];
